import { AxiosResponse, isAxiosError } from "axios";

export const handleApiCall = async <T>(apiCall: () => Promise<AxiosResponse<T>>): Promise<T> => {
  try {
    const { data } = await apiCall();
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      // keep the AxiosError instance (prototype carries `isAxiosError`) so
      // callers can still branch on `error.response?.status`
      const message = error.response?.data?.message;
      if (typeof message === "string") {
        error.message = message;
      } else if (Array.isArray(message) && message.length > 0) {
        error.message = message[0];
      }
      throw error;
    }

    throw error;
  }
};
